.row {
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  width: auto;
  justify-content: space-between;
  margin: 20px 0;
  background-color: var(--color-grey-blue);
  @include text-main;
  @include p;

  &.first-row {
  }

  > div {
    display: flex;
    flex-direction: column;
  }

  .content {
    position: relative;
    flex: 1 1 auto;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px 40px;
    padding: 40px 30px 0 30px;
    font-size: var(--font-size-xs);
  }

  .type {
    @include text-bold;
    font-size: var(--font-size-m);
  }

  .headline {
    font-size: var(--font-size-s);
  }

  .description {
    line-height: 1.4;
    height: 100%;
    overflow: hidden;
  }

  .info {
    display: grid;
    gap: 10px;

    > div {
      position: relative;
      padding-left: calc(var(--font-size-icon-m) + 10px);

      &:before {
        font-family: var(--font-icons);
        font-size: var(--font-size-icon-m);
        line-height: 1;
        font-weight: normal;
        position: absolute;
        top: 0;
        left: 0;
      }

      span {
        position: relative;
        top: 3px;
        line-height: 1;
        display: block;
        padding-bottom: 5px;
      }
    }

    .date {
      &:before {
        content: "\e927";
      }
    }

    .language {
      &:before {
        content: "\e968";
        top: -2px;
      }
    }

    .sub-type {
      color: var(--color-red);

      &:before {
        content: "\e918";
        top: -3px;
      }
    }

    .location {
      &:before {
        content: "\e915";
      }
    }
  }

  .image {
    aspect-ratio: 4/1;
    width: 100%;
    flex: 0 0 auto;
    overflow: hidden;

    img {
      width: auto;
      height: 100%;
    }
  }

  .booking {
    justify-content: center;
    align-items: center;
    padding: 10px 30px 20px 30px;
  }

  .price {
    position: absolute;
    border-radius: 0 0 5px 0;
    top: 0;
    right: unset;
    left: 0;
    align-items: end;
    padding: 4px 14px;
    width: auto;
    background-color: var(--color-red);
    color: var(--color-white);
    @include text-bold;
  }

  p {
    margin: 0;
    padding: 0;
    line-height: 1.2;
    font-size: var(--font-size-xs);
  }

  a {
    &:hover, &:focus {
      text-decoration: none;
      color: var(--color-red);
    }
  }

  &.show-map {
    .location {
      cursor: pointer;

      &:hover, &:focus {
        text-decoration: none;
        color: var(--color-red);
      }
    }
  }

  .bold {
    @include text-bold;
  }

  .offline {
    grid-column: 3;
    grid-row: 2;

    * {
      @include text-bold;
      text-decoration: none;
      line-height: 1.2;
      font-size: var(--font-size-xs);
    }
  }
}

@include media-min-width($breakpoint-l-deprecated) {
  .row {
    flex-direction: row;
    gap: 20px;

    .content {
      position: unset;
      max-height: 180px;
      min-height: 180px;
      padding: 10px 0;
    }

    .price {
      border-radius: 0 0 0 5px;
      right: 0;
      left: unset;
    }

    .booking {
      padding: 0 30px;
    }

    .image {
      aspect-ratio: 1/1;
      height: 200px;
      width: auto;
    }
  }
}

@include media-min-width($breakpoint-s) {
  .row {

    .content {
      grid-template-columns: auto 1fr;
    }

    .description {
      grid-column: span 2;
      padding-top: 5px;
    }

    .info {
      grid-row: 2;
    }
  }
}
